import styled from "styled-components";
import { TablePageContent } from "components/TablePageLayout";
import { pxToRem, withAlpha } from "../../styles/utils";

export const PageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled(TablePageContent)`
  margin-left: 0;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};
  padding: ${pxToRem(32)} ${pxToRem(24)};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${pxToRem(32)};
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(8)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.ink};
`;

export const Subtitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${pxToRem(16)};
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: ${pxToRem(16)};
`;

export const BreadcrumbsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(8)};
  font-size: ${pxToRem(20)};
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.inkMuted};
`;

export const BreadcrumbSeparator = styled.span`
  color: ${({ theme }) => withAlpha(theme.colors.ink, 0.3)};
`;

export const BreadcrumbCurrent = styled.span`
  color: ${({ theme }) => theme.colors.inkSoft};
`;
